import React, { PureComponent } from 'react';
import { SofaRadio, SofaSelectItem } from '@sofology/sofologycomponents';

import './SofaRadioWrapper.scss';

interface OwnProps {
    label: string;
    items: SofaSelectItem[];
    name: string;
    addErrorClass?: boolean | undefined;
    color?: 'default' | 'primary' | 'secondary';
    disabled?: boolean;
    helperText?: string | null;
    labelPlacement?: 'bottom' | 'end' | 'start' | 'top';
    ref?: React.RefObject<any>;
    value?: string | number | boolean | null;
    onBlur?: (e: React.SyntheticEvent) => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}


export class SofaRadioWrapper extends PureComponent<OwnProps> {
    render(): JSX.Element | null {
        return (
            <div className='sofa-radio-wrapper'>
                <div className='sofa-radio-wrapper__label'>{this.props.label}</div>
                <SofaRadio
                    {...this.props}
                    helperText={this.correctErrorMessage(this.props.helperText)}
                />
            </div>
        );
    }

    correctErrorMessage(errorMessage: string | null | undefined) {
        if (!errorMessage) {
            return null;
        }

        if (errorMessage.includes('Please provide')) {
            return 'Please select one option';
        }

        return errorMessage;
    }
}